class MenuSelector extends HTMLElement {
  button = this.querySelector('button[type="button"]');
  buttonText = this.querySelector('button[type="button"] span');
  links = this.querySelectorAll('a');
  isOpen = false;

  connectedCallback() {
    this.button?.addEventListener('click', () => {
      this.isOpen ? this.close() : this.open();
    });

    this.links?.forEach((link) => {
      link.addEventListener('click', (event) => {
        this.setLinkActive(event);
        this.close();
      });
    });

    this.closeClickOutside = (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    };
  }

  open() {
    this.classList.add('open');
    document.addEventListener('click', this.closeClickOutside);
    this.isOpen = true;
  }

  close() {
    this.classList.remove('open');
    document.removeEventListener('click', this.closeClickOutside);
    this.isOpen = false;
  }

  setLinkActive(event) {
    this.buttonText.textContent = event?.currentTarget?.textContent;
  }
}

customElements.define('menu-selector', MenuSelector);
